import React from 'react';
import Dropzone from 'react-dropzone';
import * as R from 'ramda';

import {
  Flex,
  Text,
} from 'web-styled';
import {
  Modal,
  Button,
} from 'web-components';

import File from './File';
import * as S from './styled';

type FileUpload = {
  [k: number]: {
    name: string,
  },
};

type Props = {
  title?: string;
  accept?: string;
  isOpen: boolean;
  isLoaded: boolean;
  multiple?: boolean;
  fileUpload: FileUpload;
  placeholder?: string;
  resourceType: string;
  onRequestDrop: { (files: any[]): void };
  onRequestClose: { (): void };
  onRequestCancel: { (): void };
};

const FileUploader = ({
  title,
  accept,
  isOpen,
  multiple,
  isLoaded,
  fileUpload,
  placeholder,
  resourceType,
  onRequestDrop,
  onRequestClose,
  onRequestCancel,
}: Props) => (
  <Modal
    title={title}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
  >
    <Flex column width="100%" spacing={25}>
      <Dropzone multiple={multiple} accept={accept} onDrop={onRequestDrop}>
        {({ getRootProps, getInputProps, isDragActive }) => (
          <S.StyledDropArea
            {...getRootProps()}
            isDragActive={isDragActive}
          >
            <input {...getInputProps()} />
            <Text color="#808080">
              {placeholder}
            </Text>
            <Button
              ghost
              appearance={isDragActive ? 'success' : 'primary'}
            >
              Upload From Computer
            </Button>
          </S.StyledDropArea>
        )}
      </Dropzone>
      {!R.isEmpty(fileUpload) && (
        <Flex
          column
          spacing={15}
          width="100%"
        >
          {Object.keys(fileUpload).map(key => (
            <File
              key={key}
              file={fileUpload[key]}
              source={key}
              fileUpload={fileUpload}
              resourceType={resourceType}
            />
          ))}
        </Flex>
      )}
      <Flex width="100%" justify="flex-end">
        <Button
          ghost
          appearance="primary"
          onClick={() => (isLoaded || R.isEmpty(fileUpload)
            ? onRequestClose()
            : onRequestCancel())}
        >
          {(isLoaded && !R.isEmpty(fileUpload)) ? 'Finish' : 'Cancel'}
        </Button>
      </Flex>
    </Flex>
  </Modal>
);

FileUploader.defaultProps = {
  title: 'Upload files',
  accept: '',
  placeholder: 'Drop your files here or',
  multiple: true,
};

export default FileUploader;
